const ANALYTICS_DISABLED_KEY = 'analytics_disabled';
const NOGA_QUERY_PARAM = 'noga';

function getNogaValueFromSearch(searchString = '') {
  const params = new URLSearchParams(searchString || '');
  if (!params.has(NOGA_QUERY_PARAM)) {
    return null;
  }
  return params.get(NOGA_QUERY_PARAM);
}

function getNogaValueFromHash(hashString = '') {
  if (!hashString || !hashString.includes('?')) {
    return null;
  }
  const queryString = hashString.slice(hashString.indexOf('?') + 1);
  return getNogaValueFromSearch(queryString);
}

function removeNogaFromSearch(searchString = '') {
  const params = new URLSearchParams(searchString || '');
  if (!params.has(NOGA_QUERY_PARAM)) {
    return {
      changed: false,
      search: searchString || ''
    };
  }
  params.delete(NOGA_QUERY_PARAM);
  const nextQuery = params.toString();
  return {
    changed: true,
    search: nextQuery ? `?${nextQuery}` : ''
  };
}

function removeNogaFromHash(hashString = '') {
  if (!hashString || !hashString.includes('?')) {
    return {
      changed: false,
      hash: hashString || ''
    };
  }
  const hashWithoutPound = hashString.replace(/^#/, '');
  const [hashPath, hashQuery = ''] = hashWithoutPound.split('?');
  const params = new URLSearchParams(hashQuery);
  if (!params.has(NOGA_QUERY_PARAM)) {
    return {
      changed: false,
      hash: hashString
    };
  }
  params.delete(NOGA_QUERY_PARAM);
  const nextQuery = params.toString();
  return {
    changed: true,
    hash: `#${hashPath}${nextQuery ? `?${nextQuery}` : ''}`
  };
}

// Exposed so analytics checks can honor ?noga values even before localStorage is written.
export function getNogaValueFromLocation(locationLike) {
  if (!locationLike) {
    return null;
  }
  const searchValue = getNogaValueFromSearch(locationLike.search || '');
  if (searchValue !== null) {
    return searchValue;
  }
  return getNogaValueFromHash(locationLike.hash || '');
}

export function analyticsToggleFromQuery() {
  if (typeof window === 'undefined') {
    return;
  }

  const { location, history } = window;
  if (!location || !history) {
    return;
  }

  const value = getNogaValueFromLocation(location);
  if (value === null) {
    return;
  }

  try {
    // Query toggles only control the browser-level preference; user-level admin
    // opt-outs are stored separately and stay authoritative inside analytics.js.
    if (value === '1') {
      window.localStorage.setItem(ANALYTICS_DISABLED_KEY, '1');
    } else if (value === '0') {
      window.localStorage.removeItem(ANALYTICS_DISABLED_KEY);
    }
  } catch (err) {
    // Ignore storage errors (private mode, blocked, etc.)
  }

  // Remove noga from both regular query and hash query so links remain clean after toggling.
  const { changed: searchChanged, search: nextSearch } = removeNogaFromSearch(location.search || '');
  const { changed: hashChanged, hash: nextHash } = removeNogaFromHash(location.hash || '');
  if (!searchChanged && !hashChanged) {
    return;
  }
  const nextUrl = `${location.pathname}${nextSearch}${nextHash}`;
  history.replaceState({}, '', nextUrl);
}
